import Payment from './payment';
import Grouped from './grouped';
import Breakdown from './breakdown';
Payment.Grouped = Grouped;
Payment.Breakdown = Breakdown;
export default Payment;
//# sourceMappingURL=index.js.map